import { Pipe, PipeTransform } from '@angular/core';
import { cloneDeep } from 'lodash';

@Pipe({
  name: 'cloneDeep',
  standalone: true
})
export class CloneDeepPipe implements PipeTransform {

  public transform<T>(value: T): T {
    return cloneDeep(value);
  }
}
